/**
 * Created by r4zi4l on 22.06.2022
 */

const RewardsList = function (reward, options) {
    this.options = options || {};
    this.rewards = [];

    if (cleverapps.config.debugMode && RewardsList.isEmpty(reward)) {
        cleverapps.throwAsync("RewardsList: empty reward passed");
    }

    if (Array.isArray(reward)) {
        reward.forEach((reward) => {
            this.parseReward(reward);
        });
    } else {
        this.parseReward(reward);
    }

    if (this.rewards.length === 0) {
        this.addCheapestReward();
    }

    this.rewards = this.sortRewards();

    this.commonRewards = this.rewards.filter((reward) => !Reward.isCustom(reward.descriptor.flyingAnimation));
    this.customRewards = this.rewards.filter((reward) => reward.descriptor.flyingAnimation === Reward.CUSTOM_COLLECT);
};

RewardsList.prototype.parseReward = function (reward) {
    if (reward instanceof Reward) {
        this.rewards.push(reward);
    } else {
        Object.keys(reward).forEach(function (type) {
            const value = reward[type];
            const descriptor = RewardTypes[type];

            if (!descriptor || !value) {
                return;
            }

            if (descriptor.parse) {
                this.rewards = this.rewards.concat(descriptor.parse(value, this.options));
            } else {
                this.rewards.push(new Reward(type, value, this.options));
            }
        }, this);
    }
};

RewardsList.prototype.addCheapestReward = function () {
    if (["merge", "merge2"].includes(cleverapps.config.type)) {
        if (cleverapps.config.debugMode) {
            throw "Empty rewards list";
        }

        return;
    }

    const id = cleverapps.boosters.getCheapestId();
    if (id !== undefined) {
        this.rewards.push(new Reward("boosters", { id, amount: 1 }, this.options));
    } else {
        this.rewards.push(new Reward("hard", cleverapps.Boosters.getPrice(cleverapps.Boosters.TYPES.CHEAP), this.options));
    }
};

RewardsList.prototype.pop = function (types) {
    types = cleverapps.createSet(cleverapps.toArray(types));

    const removed = [];

    this.rewards = this.rewards.filter((reward) => {
        if (types[reward.type]) {
            removed.push(reward);
            return false;
        }
        return true;
    });

    return removed;
};

RewardsList.prototype.sortRewards = function () {
    return this.rewards.filter((reward) => !reward.isFlyingUnderShadow()).concat(this.rewards.filter((reward) => reward.isFlyingUnderShadow()));
};

RewardsList.prototype.updateViewAmount = function () {
    this.rewards.forEach((reward) => reward.updateViewAmount());
};

RewardsList.prototype.receiveRewards = function () {
    if (this.received) {
        return;
    }
    this.received = true;

    this.rewards.forEach((reward) => {
        reward.receiveReward();
    });
};

RewardsList.prototype.checkReceiveRewards = function () {
    const types = {};

    this.rewards.forEach((reward) => {
        if (!types[reward.type]) {
            types[reward.type] = [];
        }

        types[reward.type].push(reward);
    });

    let receiveError;

    Object.keys(types).some((type) => {
        const check = types[type][0].descriptor.check;
        receiveError = check && check(types[type], this.options);
        return receiveError;
    });

    return receiveError;
};

RewardsList.prototype.onAnimationFinished = function () {
    this.rewards.forEach((reward) => {
        reward.onAnimationFinished();
    });
};

RewardsList.prototype.listRewards = function () {
    return this.rewards;
};

RewardsList.prototype.listControls = function () {
    return this.rewards.reduce((controls, reward) => controls.concat(reward.listControls()), []);
};

RewardsList.prototype.listBundles = function () {
    return this.rewards.reduce((controls, reward) => controls.concat(reward.listBundles()), []);
};

RewardsList.prototype.isBigReward = function () {
    return this.rewards.some((reward) => reward.descriptor.isBigReward(reward.value));
};

RewardsList.prototype.collectRewardsAnimation = function (source, options) {
    options = options || {};

    const jumpSides = ["left", "right"];
    let delay = options.delay || 0;
    const rewardsInterval = options.rewardsInterval;
    let side = 0;
    let deltaOffset = 0;
    let customRewardIndex = 0;

    this.commonRewards.forEach((reward) => {
        const rewardOptions = {
            ...options,
            jumpSide: jumpSides[side % jumpSides.length],
            delay,
            deltaOffset,
            customRewardIndex 
        };

        reward.collectRewardsAnimation(source, rewardOptions);

        if (reward.descriptor.flyingAnimation === Reward.CUSTOM_COLLECT) {
            customRewardIndex++;
        }

        if (!options.allAtOnce) {
            side += 1;
            delay += rewardsInterval === undefined ? 500 + reward.getFlyingAmount() * 250 : rewardsInterval;
            deltaOffset += cleverapps.styles.RewardsList.deltaOffset;
        }
    });
    return delay || 0;
};

RewardsList.prototype.underShadowRewardIndex = function () {
    for (let index = 0; index < this.rewards.length; ++index) {
        if (this.rewards[index].isFlyingUnderShadow()) {
            return index;
        }
    }

    return -1;
};

RewardsList.sumRewards = function (reward1, reward2) {
    const result = {};

    [reward1, reward2].forEach((reward) => {
        Object.keys(reward).forEach((type) => {
            const descriptor = RewardTypes[type] || RewardType.prototype;
            result[type] = descriptor.sumValues(reward[type], result[type]);
        });
    });

    return result;
};

RewardsList.calcCost = function (rewards) {
    let rewardList;
    if (rewards instanceof RewardsList) {
        rewardList = rewards;
    } else {
        rewardList = new RewardsList(rewards);
    }

    return rewardList.rewards.reduce((sum, reward) => sum + reward.calcPrice(), 0);
};

RewardsList.prototype.calcCostByKind = function () {
    const cost = { currency: 0, items: 0, unpriced: [] };

    this.rewards.forEach((reward) => {
        const price = reward.calcPrice();
        if (!price) {
            if (reward.getAmount() && !cost.unpriced.includes(reward.type)) {
                cost.unpriced.push(reward.type);
            }
            return;
        }
        if (reward.descriptor.currency) {
            cost.currency += price;
        } else {
            cost.items += price;
        }
    });

    return cost;
};

RewardsList.isEmpty = function (rewards) {
    if (!rewards) {
        return true;
    }

    if (rewards instanceof Reward) {
        return false;
    }

    return Object.keys(rewards).length === 0;
};

cleverapps.styles.RewardsList = {
    deltaOffset: -28
};